import { __decorate, __metadata } from "tslib";
import { appendClass } from '@1inch-community/core/lit-utils';
import '@1inch-community/ui-components/button';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { map } from 'lit/directives/map.js';
import { when } from 'lit/directives/when.js';
import { changeExpandMore } from '../../events';
import '../token-item-cross-chain-accordion-chain-view';
import { tokenItemCrossChainAccordionChainListStyle } from './token-item-cross-chain-accordion-chain-list.style';
let TokenItemCrossChainAccordionChainListElement = class TokenItemCrossChainAccordionChainListElement extends LitElement {
    constructor() {
        super(...arguments);
        this.tokenIdListWithoutBalance = [];
        this.expanded = false;
        this.showMoreChain = false;
        this.showFavoriteTokenToggle = false;
        this.mobileView = false;
    }
    static { this.tagName = 'token-item-cross-chain-accordion-chain-list'; }
    static { this.styles = tokenItemCrossChainAccordionChainListStyle; }
    render() {
        const zeroBalance = this.tokenIdListWithBalance === null || this.tokenIdListWithBalance?.length === 0;
        const showMoreButton = this.expanded && !zeroBalance;
        const list = [];
        if (this.expanded && !zeroBalance) {
            list.push(...this.tokenIdListWithBalance);
        }
        if (this.expanded && (this.showMoreChain || zeroBalance)) {
            list.push(...this.tokenIdListWithoutBalance);
        }
        appendClass(this, {
            more: this.showMoreChain,
        });
        return html `${map(list, (id) => html `
        <inch-token-item-cross-chain-accordion-chain-view
          .tokenId="${id}"
          .isFavorite="${this.favoriteTokenIds?.includes(id)}"
          .walletAddress="${this.walletAddress}"
          .showFavoriteTokenToggle="${this.showFavoriteTokenToggle}"
          .mobileView="${this.mobileView}"
        ></inch-token-item-cross-chain-accordion-chain-view>
      `)}
    ${when(showMoreButton, () => html `
      <inch-button type="link" @click="${(event) => {
            event.preventDefault();
            event.stopPropagation();
            changeExpandMore(this);
        }}">
        <span class="show-more-button-icon-container">
          <inch-icon class="show-more-button-icon less-icon" icon="minus24"></inch-icon>
          <inch-icon class="show-more-button-icon more-icon" icon="plus24"></inch-icon>
        </span>
        <inch-text-animate text="${this.showMoreChain ? 'Less' : 'More'}">
      </inch-button>
      `)} `;
    }
};
__decorate([
    property({ type: Array, attribute: false }),
    __metadata("design:type", String)
], TokenItemCrossChainAccordionChainListElement.prototype, "tokenId", void 0);
__decorate([
    property({ type: Array, attribute: false }),
    __metadata("design:type", Array)
], TokenItemCrossChainAccordionChainListElement.prototype, "tokenIdListWithoutBalance", void 0);
__decorate([
    property({ type: Array, attribute: false }),
    __metadata("design:type", Object)
], TokenItemCrossChainAccordionChainListElement.prototype, "tokenIdListWithBalance", void 0);
__decorate([
    property({ type: Boolean, attribute: false }),
    __metadata("design:type", Object)
], TokenItemCrossChainAccordionChainListElement.prototype, "expanded", void 0);
__decorate([
    property({ type: Boolean, attribute: false }),
    __metadata("design:type", Object)
], TokenItemCrossChainAccordionChainListElement.prototype, "showMoreChain", void 0);
__decorate([
    property({ type: String, attribute: false }),
    __metadata("design:type", String)
], TokenItemCrossChainAccordionChainListElement.prototype, "walletAddress", void 0);
__decorate([
    property({ type: Boolean, attribute: false }),
    __metadata("design:type", Object)
], TokenItemCrossChainAccordionChainListElement.prototype, "showFavoriteTokenToggle", void 0);
__decorate([
    property({ type: Boolean, attribute: false }),
    __metadata("design:type", Object)
], TokenItemCrossChainAccordionChainListElement.prototype, "mobileView", void 0);
__decorate([
    property({ type: Array, attribute: true }),
    __metadata("design:type", Array)
], TokenItemCrossChainAccordionChainListElement.prototype, "favoriteTokenIds", void 0);
TokenItemCrossChainAccordionChainListElement = __decorate([
    customElement(TokenItemCrossChainAccordionChainListElement.tagName)
], TokenItemCrossChainAccordionChainListElement);
export { TokenItemCrossChainAccordionChainListElement };
//# sourceMappingURL=token-item-cross-chain-accordion-chain-list.element.js.map